import React from "react";

import { Context, OneTrustPrivacyNoticeBlock as Value } from "@reactivated";

export const OneTrustPrivacyNoticeBlock = (props: { value: Value }) => {
    const context = React.useContext(Context);
    if (
        !props.value.script_url ||
        !props.value.callback_url ||
        !props.value.notice_url
    ) {
        return null;
    }
    // Take a URL like:
    //   "https://privacyportalde-cdn.onetrust.com/06f33c68-93f3-46c6-a3ad-8ae86016fdeb/privacy-notices/a863b2f8-c121-4608-b0b7-cac4181c95e0.json"
    // And extract the last UUID:
    //   "a863b2f8-c121-4608-b0b7-cac4181c95e0"
    const noticeUUIDMatches = props.value.notice_url.match(
        /([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?=\.json$)/,
    );
    if (!noticeUUIDMatches) {
        return null;
    }
    const noticeUUID = noticeUUIDMatches[0];
    // Build script settings
    const encodedSettings = btoa(
        JSON.stringify({
            callbackUrl: props.value.callback_url,
        }),
    );
    return (
        <>
            <div id={`otnotice-${noticeUUID}`} className="otnotice"></div>
            <script
                src={props.value.script_url}
                type="text/javascript"
                id="otprivacy-notice-script"
                nonce={context.request.csp_nonce || undefined}
                dangerouslySetInnerHTML={{
                    __html: `settings="${encodedSettings}"`,
                }}
            />
            <script
                type="text/javascript"
                nonce={context.request.csp_nonce || undefined}
                dangerouslySetInnerHTML={{
                    __html: `
                        OneTrust.NoticeApi.Initialized.then(function() {
                          OneTrust.NoticeApi.LoadNotices(["${props.value.notice_url}"]);
                        });
                    `,
                }}
            />
        </>
    );
};
